import { Observable } from 'rxjs'
import { first, flatMap } from 'rxjs/operators'
import { environment } from 'src/environments/environment'

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'

import { authSelectors } from '../auth/auth.selectors'
import { AppState } from '../core.state'

@Injectable()
export class PlatformInterceptor implements HttpInterceptor {
  constructor(private store: Store<AppState>) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return this.store.select(authSelectors.selectMember).pipe(
      first(),
      flatMap((member) => {
        if (member && request?.url?.includes(environment.backendApiUrl)) {
          request = request.clone({
            setHeaders: {
              'x-platform': 'AP'
            }
          })
        }

        return next.handle(request)
      })
    )
  }
}
